/**
 * Мост «открыть пополнение». Интерсептор `api` (shared/api/base.ts) ловит
 * ошибку недостатка баланса и зовёт `requestOpenTopUpModal()` — а показывает
 * пакеты тот, кто зарегистрировал opener (сайдбар на вебе, таб-бар в миниаппе).
 *
 * У балансов разные пакеты: обычный поток тратит `songs`, заявка на релиз —
 * `releases` (пакеты `kind=release`, отдельного `filters.type` для них у бэка
 * нет). Поэтому мост знает про ВИД баланса:
 *  - `withTopUpBalanceKind` помечает, какой баланс тратит конкретный запрос
 *    (интерсептор срабатывает внутри этого вызова и подхватывает вид);
 *  - `registerTopUpBalanceOpener` позволяет странице показать СВОИ пакеты
 *    вместо глобальной модалки (страница релиза — свои `kind=release`).
 * Без этих вызовов поведение прежнее: `songs` + глобальный opener.
 */
let opener = null;
const kindOpeners = new Map();
let currentKind = "songs";
let lastOpenAt = 0;
const OPEN_COOLDOWN_MS = 2500;
export function registerTopUpModalOpener(fn) {
    opener = fn;
}
/**
 * Переопределить пополнение конкретного баланса (страница сама рисует свои
 * пакеты). `null` — снять переопределение (обязательно в cleanup эффекта).
 */
export function registerTopUpBalanceOpener(kind, fn) {
    if (fn) {
        kindOpeners.set(kind, fn);
    }
    else {
        kindOpeners.delete(kind);
    }
}
/**
 * Выполнить запрос, помеченный видом баланса: пока промис не завершился,
 * `requestOpenTopUpModal()` без аргумента откроет пополнение именно этого
 * баланса. Интерсептор ответа отрабатывает внутри `await`, поэтому пометка
 * гарантированно активна в момент ошибки.
 */
export async function withTopUpBalanceKind(kind, run) {
    const previous = currentKind;
    currentKind = kind;
    try {
        return await run();
    }
    finally {
        currentKind = previous;
    }
}
export function requestOpenTopUpModal(kind = currentKind) {
    const now = Date.now();
    if (now - lastOpenAt < OPEN_COOLDOWN_MS) {
        return;
    }
    lastOpenAt = now;
    try {
        const scoped = kindOpeners.get(kind);
        if (scoped) {
            scoped();
            return;
        }
        opener?.(kind);
    }
    catch (e) {
        console.error("requestOpenTopUpModal", e);
    }
}
